import { render } from "./AudienceLabels.vue?vue&type=template&id=f7e9a5ae"
import script from "./AudienceLabels.vue?vue&type=script&lang=js"
export * from "./AudienceLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__